import React from "react";
import MUIGrid, {
  Grid2Props as MUIGridProps
} from "@mui/material/Unstable_Grid2";

export function Grid({ children, ...props }: MUIGridProps) {
  return <MUIGrid {...props}>{children}</MUIGrid>;
}
